export default __webpack_public_path__ + "assets/audios/8e31e82cfef807d4260600b69c101027.mp3";